import Constants from "expo-constants";

export type LaunchArguments = Record<string, unknown>;

export function isE2ETest(): boolean {
  return Constants.expoConfig?.extra?.e2e === true;
}

export function getString(name: string): string | undefined {
  const launchArgs = Constants.expoConfig?.extra?.launchArgs as LaunchArguments | undefined;
  const value = launchArgs?.[name];
  return typeof value === "string" ? value : undefined;
}

export function getBoolean(name: string): boolean | undefined {
  const launchArgs = Constants.expoConfig?.extra?.launchArgs as LaunchArguments | undefined;
  const value = launchArgs?.[name];
  return typeof value === "boolean" ? value : undefined;
}

export function useLaunchArguments(): LaunchArguments {
  return (Constants.expoConfig?.extra?.launchArgs as LaunchArguments) || {};
}
